'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { MinimizedBetaButton } from './MinimizedBetaButton';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const OptMinimized = ({
  onMaximized = emptyFunction
}) => {
  return /*#__PURE__*/_jsx(MinimizedBetaButton, {
    onClick: onMaximized,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ui-addon-opt.beta"
    })
  });
};
export default OptMinimized;